import React from 'react';
import AdminLayout from './AdminLayout';
import UserManagement from './UserManagement';

const AdminUsersPage = () => {
  return (
    <AdminLayout
      title="User Management"
      description="Assign roles, manage module visibility, and toggle advanced Threads tools for advisors per the RBAC requirements."
    >
      <UserManagement />
    </AdminLayout>
  );
};

export default AdminUsersPage;
